import { translationKey, type TranslationKey } from '@change-corgi/core/i18n';

export const MESSAGE_VALUES: Record<string, TranslationKey> = {
	set_password: translationKey('fe.pages.set_new_password.success_message'),
};
